export default {
    _prefix: "Error",
    403: "Forbidden",
    404: "Sorry, we did not recognize that URL.",
};
